import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useIgdChartsDataContext } from './hooks/useIgdChartsDataContext';

export const HealthScheduleAnual = () => {
    const { chartData } = useIgdChartsDataContext();


    return (
        <SimpleBars
            title={'Taxa de Acompanhamento de Agenda de Saúde (Anual)'}
            horizontal={false}
            subtitles={chartData?.healthScheduleAnual?.map((item) => getYearLabel(item.ano))}
            values={chartData?.healthScheduleAnual?.map((item) => item.value  ||  0)}
        />
    );
};
